// pp-facturacion-publica.js — Wizard de facturación pública CFDI 4.0
//
// Esta página sólo PINTA. Todo lo demás —las llamadas a la edge function
// `facturacion-publica`, las validaciones, el payload de /emitir y la
// protección contra facturas dobles (#152338: «emisión sin espera»)— vive en
// assets/pp-facturacion-nucleo.js (window.PPFacturacionNucleo), el ÚNICO
// emisor de CFDI del tema: lo comparten esta página y la vista «Facturar» de
// Paco (assets/pp-paco3.js). La sección carga el núcleo antes que este
// archivo (los dos con defer, en ese orden).
//
// Extraído el 3-oct-2026 sin cambiar nada visible: lo amarra
// tests/facturacion-pagina-sin-cambios.test.mjs, que corre la versión
// anterior (tests/fixtures/pp-facturacion-publica-antes-del-nucleo.js) y ésta
// sobre el mismo DOM y la misma red falsa y compara pantalla y llamadas.

(function () {
  'use strict';

  var N = window.PPFacturacionNucleo;
  if (!N) return; // sin el núcleo no hay con qué facturar (la sección lo carga antes)
  var cliente = N.crearCliente({});

  // ── Refs DOM ───────────────────────────────────────────────────
  var step1 = document.querySelector('[data-step="1"]');
  var step2 = document.querySelector('[data-step="2"]');
  var step3 = document.querySelector('[data-step="3"]');
  if (!step1 || !step2 || !step3) return;

  var formOrder = step1.querySelector('form.invoice-order');
  var inputOrder = document.getElementById('invoice-order');
  var inputTotal = document.getElementById('invoice-total');
  var errorEl = step1.querySelector('[data-pp-facpub-error]');

  var summaryMetaEl = document.querySelector('[data-pp-facpub-summary-meta]');
  var summaryTableBody = document.querySelector('.invoice-table');

  var fiscalForm = step3.querySelector('form');
  var btnGenerar = document.querySelector('.btn-generar-factura');
  var errorFiscalEl = step3.querySelector('[data-pp-facpub-error-fiscal]');

  var inputRfc = document.getElementById('fiscal-rfc');
  var inputNombre = document.getElementById('fiscal-nombre');
  var inputCfdi = document.getElementById('fiscal-cfdi');
  var inputRegimen = document.getElementById('fiscal-regimen');
  var inputEmail = document.getElementById('fiscal-email');
  var inputZip = document.getElementById('fiscal-zip');

  var profilesWrap = document.querySelector('[data-pp-facpub-profiles]');
  var profilesSelect = document.getElementById('fiscal-infos');

  // ── Estado ─────────────────────────────────────────────────────
  // orderContext guarda { order_id, order_number, total, needs_payment_form,
  // suggested_payment_form, es_mes_anterior_en_ventana, mensaje_ventana }
  // tras lookup exitoso. Se usa para construir el payload de emitir.
  var orderContext = null;
  // selectedProfile guarda el objeto del perfil elegido (si el usuario
  // selecciona uno del dropdown). Modo A vs Modo B en emitir.
  var selectedProfile = null;

  // ── Helpers ────────────────────────────────────────────────────
  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideError(el) {
    if (!el) return;
    el.textContent = '';
    el.hidden = true;
  }

  function setStepVisible(stepEl, visible) {
    if (visible) {
      stepEl.hidden = false;
      stepEl.classList.add('pp-facpub__step--active');
    } else {
      stepEl.classList.remove('pp-facpub__step--active');
    }
  }

  function clearChildren(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  function makeMetaBlock(label, value) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(label));
    var strong = document.createElement('strong');
    strong.textContent = value;
    div.appendChild(strong);
    return div;
  }

  var formatMoney = N.formatMoney;
  var formatDate = N.formatDate;

  // Aviso informativo (no rojo): reutiliza el contenedor de error con un tono.
  function showInfo(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    el.classList.add('pp-facpub__form-error--info');
  }
  function limpiarTono(el) {
    if (el) el.classList.remove('pp-facpub__form-error--info');
  }

  // ── STEP 1: Lookup orden ───────────────────────────────────────
  function handleLookup(e) {
    e.preventDefault();
    hideError(errorEl);

    var paso1 = N.validarLookup(inputOrder.value || '', inputTotal.value || '');
    if (!paso1.ok) {
      return showError(errorEl, paso1.error);
    }

    var submitBtn = formOrder.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.origText = submitBtn.textContent;
      submitBtn.textContent = 'Buscando…';
    }

    cliente.lookup(paso1.orderNumber, paso1.total)
      .then(function (result) {
        var r = N.interpretarLookup(result);
        // 422 no-pagada CON resumen (#3383): quien acreditó número + total ya
        // demostró posesión de la orden — mostramos qué va a facturar + el
        // mensaje de pago pendiente, en vez de degradar a un error seco.
        if (r.tipo === 'pendiente') {
          renderPendingPayment(r.order, r.error);
          return;
        }
        if (r.tipo === 'error' || r.tipo === 'inesperado') {
          return showError(errorEl, r.error);
        }
        // Caso: ya facturada → mostrar links de descarga en vez de form fiscal
        if (r.tipo === 'ya_facturada') {
          renderAlreadyInvoiced(r.factura);
          return;
        }

        // Caso normal: puede facturar
        var order = r.order;

        orderContext = order;
        renderSummary(order);
        applyMesAnteriorBanner(order);
        applyPaymentFormSelector(order);

        setStepVisible(step1, false);
        setStepVisible(step2, true);
        setStepVisible(step3, true);
        step2.scrollIntoView({ behavior: 'smooth', block: 'start' });

        // Pre-fill email del customer logueado si está disponible
        if (window.PP_CUSTOMER_EMAIL && !inputEmail.value) {
          inputEmail.value = window.PP_CUSTOMER_EMAIL;
        }
        // Pre-fill desde la orden si el customer no está logueado
        if (!inputEmail.value && order.customer_email) {
          inputEmail.value = order.customer_email;
        }
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.origText || 'Buscar orden';
        }
      });
  }

  // ── Mensaje ventana SAT (mes anterior, dentro de 72h) ──────────
  function applyMesAnteriorBanner(order) {
    var existing = document.querySelector('[data-pp-facpub-ventana]');
    if (existing) existing.remove();
    if (!order.es_mes_anterior_en_ventana || !order.mensaje_ventana) return;
    var banner = document.createElement('div');
    banner.className = 'pp-facpub__ventana';
    banner.setAttribute('data-pp-facpub-ventana', '');
    banner.textContent = order.mensaje_ventana;
    step2.insertBefore(banner, step2.firstChild.nextSibling);
  }

  // ── Selector de forma de pago (solo si la orden lo requiere) ───
  function applyPaymentFormSelector(order) {
    var existing = document.querySelector('[data-pp-facpub-payment-form]');
    if (existing) existing.remove();
    if (!order.needs_payment_form) return;

    var wrap = document.createElement('div');
    wrap.className = 'pp-facpub__field pp-facpub__field--full';
    wrap.setAttribute('data-pp-facpub-payment-form', '');

    var label = document.createElement('label');
    label.className = 'pp-facpub__label';
    label.setAttribute('for', 'fiscal-payment-form');
    label.appendChild(document.createTextNode('Forma de pago '));
    var req = document.createElement('span');
    req.className = 'pp-facpub__req';
    req.textContent = '*';
    label.appendChild(req);
    wrap.appendChild(label);

    var sel = document.createElement('select');
    sel.id = 'fiscal-payment-form';
    sel.className = 'pp-facpub__select';
    // Catálogo SAT c_FormaPago: vive en el núcleo (lo comparte Paco).
    var opts = N.FORMAS_PAGO;
    opts.forEach(function (o) {
      var opt = document.createElement('option');
      opt.value = o[0];
      opt.textContent = o[1];
      if (o[0] === (order.suggested_payment_form || '03')) opt.selected = true;
      sel.appendChild(opt);
    });
    wrap.appendChild(sel);

    var hint = document.createElement('small');
    hint.className = 'pp-facpub__hint';
    hint.textContent = 'Esta orden no tiene forma de pago registrada — confirma cómo pagaste.';
    wrap.appendChild(hint);

    // Insertar al inicio del form fiscal (antes del primer field)
    var firstField = fiscalForm.querySelector('.pp-facpub__field');
    if (firstField) {
      fiscalForm.insertBefore(wrap, firstField);
    } else {
      fiscalForm.insertBefore(wrap, fiscalForm.firstChild);
    }
  }

  // ── STEP 2: Render del resumen ─────────────────────────────────
  function renderSummary(order) {
    if (summaryMetaEl) {
      clearChildren(summaryMetaEl);
      var numText = order.order_number || '';
      var dateText = formatDate(order.shopify_created_at || order.created_at);
      var totalText = formatMoney(order.total);
      summaryMetaEl.appendChild(makeMetaBlock('NÚMERO', numText));
      if (dateText) summaryMetaEl.appendChild(makeMetaBlock('FECHA', dateText));
      summaryMetaEl.appendChild(makeMetaBlock('TOTAL', totalText));
    }

    if (summaryTableBody && Array.isArray(order.line_items)) {
      clearChildren(summaryTableBody);
      order.line_items.forEach(function (li) {
        var tr = document.createElement('tr');
        var tdSku = document.createElement('td');
        tdSku.textContent = li.sku || '—';
        var tdTitle = document.createElement('td');
        tdTitle.textContent = li.name || '';
        var tdQty = document.createElement('td');
        tdQty.className = 'pp-facpub__table-num';
        tdQty.textContent = String(li.quantity || 0);
        var tdTotal = document.createElement('td');
        tdTotal.className = 'pp-facpub__table-num';
        tdTotal.textContent = formatMoney(li.line_total);
        tr.appendChild(tdSku);
        tr.appendChild(tdTitle);
        tr.appendChild(tdQty);
        tr.appendChild(tdTotal);
        summaryTableBody.appendChild(tr);
      });
    }
  }

  // ── Caso: orden no pagada (422 not_paid con resumen, #3383) ────
  // Renderiza el resumen "esto vas a facturar" + banner de pago pendiente.
  // El form fiscal (step 3) queda oculto → no hay botón Emitir activo.
  function renderPendingPayment(order, backendMessage) {
    renderSummary(order);

    var existing = document.querySelector('[data-pp-facpub-pendiente]');
    if (existing) existing.remove();
    var banner = document.createElement('div');
    banner.className = 'pp-facpub__ventana pp-facpub__ventana--warn';
    banner.setAttribute('data-pp-facpub-pendiente', '');
    banner.textContent = (backendMessage || 'Esta orden no está pagada todavía.') +
      ' Paga tu orden para poder facturar; en cuanto se registre tu pago podrás emitir tu CFDI aquí.';
    step2.insertBefore(banner, step2.firstChild.nextSibling);

    setStepVisible(step1, false);
    setStepVisible(step2, true);
    step3.hidden = true;
    step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ── Caso: orden ya facturada (links de descarga inmediatos) ────
  function renderAlreadyInvoiced(factura) {
    if (!factura) return;
    clearChildren(step2);
    var wrap = document.createElement('div');
    wrap.className = 'pp-facpub__already';

    var h = document.createElement('h2');
    h.className = 'pp-facpub__step-title';
    h.textContent = 'Esta orden ya tiene factura';
    wrap.appendChild(h);

    var p = document.createElement('p');
    p.className = 'pp-facpub__step-sub';
    p.appendChild(document.createTextNode('CFDI emitido a '));
    var strong = document.createElement('strong');
    strong.textContent = factura.razon_social || factura.rfc_receptor || '';
    p.appendChild(strong);
    p.appendChild(document.createTextNode('. Folio ' + (factura.folio || '—') + '.'));
    wrap.appendChild(p);

    var links = document.createElement('div');
    links.className = 'pp-facpub__success-links';
    if (factura.has_pdf) {
      var btnPdf = document.createElement('button');
      btnPdf.type = 'button';
      btnPdf.className = 'pp-facpub__btn pp-facpub__btn--primary';
      btnPdf.textContent = 'Descargar PDF';
      btnPdf.addEventListener('click', function () { downloadInvoice(factura.id, 'pdf'); });
      links.appendChild(btnPdf);
    }
    if (factura.has_xml) {
      var btnXml = document.createElement('button');
      btnXml.type = 'button';
      btnXml.className = 'pp-facpub__btn';
      btnXml.textContent = 'Descargar XML';
      btnXml.addEventListener('click', function () { downloadInvoice(factura.id, 'xml'); });
      links.appendChild(btnXml);
    }
    wrap.appendChild(links);

    step2.appendChild(wrap);
    setStepVisible(step1, false);
    setStepVisible(step2, true);
    step3.hidden = true;
    step2.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // La descarga (liga firmada → blob → <a download>) vive en el núcleo; aquí
  // sólo se avisa con alert() si falla, como siempre.
  function downloadInvoice(facturaId, tipo) {
    cliente.descargar(facturaId, tipo, document, URL).then(function (r) {
      if (!r.ok) alert(r.error);
    });
  }

  // ── STEP 3: Cargar perfiles fiscales guardados ─────────────────
  function loadCustomerProfiles() {
    if (!window.PP_CUSTOMER_EMAIL || !profilesSelect || !profilesWrap) return;
    // El edge deriva la cuenta de la ORDEN validada (número + total), no del email.
    // Mandamos ambos: order+total es lo que el edge nuevo exige (cierra el IDOR/enum);
    // el email queda por compatibilidad con el edge viejo durante el despliegue. Sin
    // una orden validada no pedimos perfiles (el edge lo rechazaría).
    if (!orderContext) return;
    cliente.perfiles(orderContext, window.PP_CUSTOMER_EMAIL)
      .then(function (result) {
        if (!result.ok) return;
        var profiles = (result.data && result.data.profiles) || [];
        if (profiles.length === 0) return;

        profiles.forEach(function (p) {
          var opt = document.createElement('option');
          opt.value = String(p.id);
          opt.textContent = (p.rfc || '') + ' — ' + (p.legal_name || '');
          opt.dataset.profile = JSON.stringify(p);
          profilesSelect.appendChild(opt);
        });
        profilesWrap.hidden = false;

        var defaultProfile = N.perfilPorDefecto(profiles);
        if (defaultProfile) {
          profilesSelect.value = String(defaultProfile.id);
          fillFromProfile(defaultProfile);
          selectedProfile = defaultProfile;
        }
      });
  }

  // «Sube tu constancia y llenamos los datos por ti» (13-oct-2026). La lectura
  // exige el pedido ya probado en el paso 1: sin él no hay a quién cobrarle el
  // tope. Los campos avisan con `input`, así que un perfil guardado elegido se
  // suelta igual que si el cliente tecleara.
  var bloqueConstancia = document.querySelector('[data-pp-facpub-constancia]');
  if (bloqueConstancia && window.PPFiscalConstancia && window.PPFiscalConstancia.conectar) {
    window.PPFiscalConstancia.conectar(bloqueConstancia, {
      campos: { rfc: inputRfc, legal_name: inputNombre, zip_code: inputZip, tax_system: inputRegimen, uso: inputCfdi },
      accion: 'genera tu factura',
      lectura: function () {
        if (!orderContext) return null;
        return { endpoint: N.FACT_BASE + '/leer-constancia', extra: { order_number: orderContext.order_number, total: orderContext.total } };
      }
    });
  }

  function fillFromProfile(p) {
    var f = N.fiscalDePerfil(p, window.PP_CUSTOMER_EMAIL);
    if (!f) return;
    if (inputRfc) inputRfc.value = f.rfc;
    if (inputNombre) inputNombre.value = f.legal_name;
    if (inputCfdi) inputCfdi.value = f.cfdi_use;
    if (inputRegimen) inputRegimen.value = f.tax_system;
    if (inputEmail) inputEmail.value = f.email_cfdi;
    if (inputZip) inputZip.value = f.zip_code;
  }

  if (profilesSelect) {
    profilesSelect.addEventListener('change', function () {
      var opt = profilesSelect.selectedOptions[0];
      if (!opt || !opt.dataset.profile) {
        selectedProfile = null;
        return;
      }
      try {
        selectedProfile = JSON.parse(opt.dataset.profile);
        fillFromProfile(selectedProfile);
      } catch (_) {
        selectedProfile = null;
      }
    });
  }

  // Cuando el usuario edita CUALQUIER campo después de elegir un perfil,
  // se invalida la selección — caemos a modo B (inline) para que el backend
  // tome los datos modificados, no los del perfil guardado.
  ['fiscal-rfc', 'fiscal-nombre', 'fiscal-cfdi', 'fiscal-regimen', 'fiscal-email', 'fiscal-zip']
    .forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('input', function () { selectedProfile = null; });
    });

  // ── STEP 3: Emitir factura ─────────────────────────────────────
  function handleEmit(e) {
    e.preventDefault();
    hideError(errorFiscalEl);

    var fiscalData = N.datosFiscales({
      rfc: inputRfc && inputRfc.value,
      legal_name: inputNombre && inputNombre.value,
      cfdi_use: inputCfdi && inputCfdi.value,
      tax_system: inputRegimen && inputRegimen.value,
      email_cfdi: inputEmail && inputEmail.value,
      zip_code: inputZip && inputZip.value
    });
    // Payment form opcional (solo cuando el backend indicó needs_payment_form)
    var paymentFormSel = document.getElementById('fiscal-payment-form');
    var paymentForm = paymentFormSel ? paymentFormSel.value : null;

    var falla = N.validarFiscal(orderContext, fiscalData, paymentForm);
    if (falla) {
      return showError(errorFiscalEl, falla.mensaje);
    }

    var payload = N.construirPayload(orderContext, fiscalData, selectedProfile, paymentForm);

    btnGenerar.setAttribute('disabled', 'disabled');
    var origText = btnGenerar.textContent;
    btnGenerar.textContent = 'Generando…';
    limpiarTono(errorFiscalEl);

    // El núcleo emite UNA vez; si no hay respuesta clara, consulta (nunca
    // reemite). El botón se queda deshabilitado mientras espera — un segundo
    // clic aquí es justo lo que produjo la doble factura de #152338.
    cliente.emitir(orderContext, payload, function (mensaje) {
      showInfo(errorFiscalEl, mensaje);
    })
      .then(function (r) {
        if (r.tipo === 'emitida') {
          renderSuccess(r.data, fiscalData.email_cfdi, false);
          step3.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (r.tipo === 'lista') {
          limpiarTono(errorFiscalEl);
          hideError(errorFiscalEl);
          renderSuccess(r.data, fiscalData.email_cfdi, r.archivosEnCamino);
          step3.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (r.tipo === 'sin_confirmar') limpiarTono(errorFiscalEl);
        showError(errorFiscalEl, r.mensaje);
      })
      .finally(function () {
        if (btnGenerar) {
          btnGenerar.removeAttribute('disabled');
          btnGenerar.textContent = origText;
        }
      });
  }

  // Reemplaza el form fiscal con un panel de éxito + descargas.
  // `archivosEnCamino`: la factura ya está timbrada pero el PDF/XML aún se
  // están generando; los botones de descarga los piden a Facturama en el
  // momento, así que se ofrecen igual.
  function renderSuccess(data, emailTo, archivosEnCamino) {
    if (!fiscalForm) return;
    clearChildren(fiscalForm);

    var wrap = document.createElement('div');
    wrap.className = 'pp-facpub__success';

    var h3 = document.createElement('h3');
    h3.textContent = '¡Factura generada!';
    wrap.appendChild(h3);

    var p = document.createElement('p');
    if (archivosEnCamino) {
      p.appendChild(document.createTextNode('Tu factura ya se emitió (folio ' + (data.folio || '—') + '). Estamos generando tus archivos PDF y XML; en unos minutos te llegan a '));
      var strongEmail2 = document.createElement('strong');
      strongEmail2.textContent = emailTo;
      p.appendChild(strongEmail2);
      p.appendChild(document.createTextNode('. También puedes descargarlos aquí.'));
    } else {
      p.appendChild(document.createTextNode('Te enviamos el PDF y XML a '));
      var strongEmail = document.createElement('strong');
      strongEmail.textContent = emailTo;
      p.appendChild(strongEmail);
      p.appendChild(document.createTextNode('. Folio ' + (data.folio || '—') + '.'));
    }
    wrap.appendChild(p);

    var links = document.createElement('div');
    links.className = 'pp-facpub__success-links';
    var facturaId = data.factura_id;
    if (facturaId) {
      var btnPdf = document.createElement('button');
      btnPdf.type = 'button';
      btnPdf.className = 'pp-facpub__btn pp-facpub__btn--primary';
      btnPdf.textContent = 'Descargar PDF';
      btnPdf.addEventListener('click', function () { downloadInvoice(facturaId, 'pdf'); });
      links.appendChild(btnPdf);

      var btnXml = document.createElement('button');
      btnXml.type = 'button';
      btnXml.className = 'pp-facpub__btn';
      btnXml.textContent = 'Descargar XML';
      btnXml.addEventListener('click', function () { downloadInvoice(facturaId, 'xml'); });
      links.appendChild(btnXml);
    }
    wrap.appendChild(links);

    fiscalForm.appendChild(wrap);
  }

  // ── ?orden= ───────────────────────────────────────────────────
  // Paco (vista «Facturar» del panel, 3-oct-2026) manda aquí con el número
  // ya puesto: /pages/facturacion?orden=1234. Sólo dígitos; lo demás se
  // ignora (la página sigue igual que sin parámetro). El total lo teclea el
  // cliente: es la prueba de que la orden es suya. La regla, en el núcleo.
  var ordenDeLaUrl = N.ordenDeLaUrl;

  // ── Wire ───────────────────────────────────────────────────────
  if (inputOrder && !inputOrder.value) {
    inputOrder.value = ordenDeLaUrl(window.location.search);
    if (inputOrder.value && inputTotal) inputTotal.focus();
  }
  if (formOrder) formOrder.addEventListener('submit', handleLookup);
  if (btnGenerar) btnGenerar.addEventListener('click', handleEmit);

  if (window.PP_CUSTOMER_EMAIL) {
    loadCustomerProfiles();
  }
})();
